import React from 'react';
import { useNavigate } from 'react-router-dom';
import './LatestSets.css';

// Same slugging as SetsPage so links land on the same routes.
const setSlug = (name) => name.toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '');

// "Latest" carousel under the hero: the newest sets, logo front and center.
// The leftmost (newest) set gets a "New" badge. countsByName maps a set name
// to how many live listings it has (computed client-side by the caller).
const LatestSets = ({ sets, countsByName }) => {
    const navigate = useNavigate();
    if (!sets || sets.length === 0) return null;

    return (
        <section className="gh-latest" aria-label="Latest sets">
            <h2 className="gh-latest-title">Latest</h2>
            <div className="gh-latest-track">
                {sets.map((s, i) => {
                    const count = countsByName?.[s.name] || 0;
                    return (
                        <button
                            key={s.id || s.name}
                            type="button"
                            className="gh-latest-card"
                            onClick={() => navigate(`/sets/${setSlug(s.name)}`)}
                        >
                            {i === 0 && <span className="gh-latest-new">New</span>}
                            <span className="gh-latest-logo">
                                {s.logo_image ? (
                                    <img src={s.logo_image} alt={`${s.name} logo`} loading="lazy" />
                                ) : (
                                    <span className="gh-latest-noimg">{s.name}</span>
                                )}
                            </span>
                            <span className="gh-latest-meta">
                                <span className="gh-latest-name">{s.name}</span>
                                <span className="gh-latest-sub">
                                    <span className="gh-latest-series">{s.series}</span>
                                    <span className="gh-latest-count">
                                        {count > 0 ? `${count} listing${count === 1 ? '' : 's'}` : 'View'}
                                    </span>
                                </span>
                            </span>
                        </button>
                    );
                })}
            </div>
        </section>
    );
};

export default LatestSets;
